import PhoneUtils from '@/utils/PhoneUtils';
import { OldAPI } from './../OldClient';

namespace PhoneService {

    export async function isMobilePhone(phone: string): Promise<boolean> {
        const sanitizedPhoneNumber = PhoneUtils.sanitizePhoneNumber(phone);
        try {
            await OldAPI.get('/users/lookUp', {
                params: {
                    phoneNumber: sanitizedPhoneNumber
                }
            });

            return true;
        } catch (e) {
            return false;
        }
    }

    export async function sendDownloadLink(phone: string): Promise<void> {
        const sanitizedPhoneNumber = PhoneUtils.sanitizePhoneNumber(phone);
        await OldAPI.post('/users/sendDownloadLink', {
            phoneNumber: sanitizedPhoneNumber
        });
    }
}

export default PhoneService;